import {
  formatPrice,
  fetchProducts,
} from '~js/utilities/products-and-collections';

// INHERITS cartItem in scope

const lineItemComponent = (
  lowStockThreshold,
  lowStockMessage,
  normalStockMessage
) => ({
  lowStockThreshold,
  lowStockMessage,
  normalStockMessage,
  isRemoving: false,
  fullVariantData: {},

  async init() {
    const currentAllProducts = await fetchProducts([this.cartItem.product_id]);
    const cartItemProductData = currentAllProducts[this.cartItem.product_id];
    const cartItemVariantData = cartItemProductData.variants.find(
      (variant) =>
        variant.id.replace('gid://shopify/ProductVariant/', '') ===
        this.cartItem.variant_id.toString()
    );
    this.fullVariantData = cartItemVariantData;
  },

  async removeItem(key, isGiftBox = false) {
    const { $store } = this;
    try {
      this.isRemoving = true;
      if (isGiftBox) {
        await $store.cart.clearGiftBoxAttributes();
      }
      let withGift = this.$store.cart.cartData.items.find(
        item => item.product_id === window.GIFT_WITH_PURCHASE_PRODUCT_ID && item.final_price === 0 && item.properties?.__isGiftWithPurchase === "GWP"
      );
      let itemToRemove = this.$store.cart.cartData.items.find(
        item => item.key === key
      );
      const gwpProduct = this.$store.cart.cartData.items.find(
        item => item.properties?.__isFreeGift === "__isFreeGift" && item.properties?.__productIdRequired == itemToRemove.product_id && item.final_price === 0
      );
      let withCollectionGift = this.$store.cart.cartData.items.find(
        item => item.product_id === window.COLLECTION_GWP_PRODUCT_ID && item.properties?.__collectionFreeGift === "__collectionFreeGift"
      );
      const updates = {};
      if(withGift && this.totalForProgressCalculation - itemToRemove.final_line_price / 100 < window.GIFT_WITH_PURCHASE_MINIMUM_CART_VALUE || gwpProduct || withCollectionGift){
        if(withGift && this.totalForProgressCalculation - itemToRemove.final_line_price / 100 < window.GIFT_WITH_PURCHASE_MINIMUM_CART_VALUE){
          updates[withGift.key] = 0;
        }
        if(gwpProduct){
          const itemToRemoveId = itemToRemove.product_id;
          const variantsWithGwp = this.$store.cart.cartData.items.filter(item => item.product_id === itemToRemoveId )

          if(variantsWithGwp.length > 1){
            const totalQty = variantsWithGwp.reduce((acc, item) => acc + item.quantity, 0);
            const totalGwpQty = totalQty - itemToRemove.quantity;
            updates[gwpProduct.key] = totalGwpQty;
          }else{
            updates[gwpProduct.key] = 0;
          }
        }

        if(withCollectionGift){
          const percentageTotal = this.$store.cart.percentageReachedCollectionGwp;
          const percentageRemoved = (itemToRemove.final_line_price / 100) / this.$store.cart.collectionGWP?.gwpProductAmount?.value * 100;
          if(percentageTotal - percentageRemoved < 100){
            updates[withCollectionGift.key] = 0;
          }
        }
        updates[key] = 0;
        await this.$store.cart.updateCart({updates})
      }else{
        await $store.cart.removeLineItem(key);
      }
    } catch {
      alert('sorry, there was an error removing this item from your cart');
    } finally {
      this.isRemoving = false;
    }
  },

  get imageUrl() {
    return this.cartItem.featured_image.url;
  },
  get imageAlt() {
    return this.cartItem.featured_image.alt;
  },
  get imageWidth() {
    return this.cartItem.featured_image.width;
  },
  get imageHeight() {
    return this.cartItem.featured_image.height;
  },

  get isBackorderTaggedProduct() {
    return this.fullVariantData.product?.tags.includes('backorder');
  },

  get isBackorderMarkedVariant() {
    return this.fullVariantData.isBackorder?.value == 'true';
  },

  get backOrderShippingDate() {
    return this.fullVariantData.backOrderShippingDate?.value;
  },

  get isFinalSale() {
    const { fullVariantData } = this;
    const product = fullVariantData.product;
    const regex = new RegExp('^S[0-9]{6}');
    let isFinalSale = false;

    product?.tags.forEach((tag) => {
      if (tag == 'FINALSALE' || tag == 'tempfinalsale' || regex.test(tag)) {
        isFinalSale = true;
      }
    });
    return isFinalSale;
  },

  get isLowStock() {
    const { fullVariantData, lowStockThreshold } = this;
    if (fullVariantData.quantityAvailable) {
      return fullVariantData.quantityAvailable <= lowStockThreshold;
    } else return true;
  },

  get discountStatus() {
    const { fullVariantData, cartItem } = this;
    if (cartItem.discounts.length) {
      return 'APPLIED';
    } else if (
      fullVariantData.compareAtPrice &&
      parseFloat(fullVariantData.compareAtPrice.amount) >
        parseFloat(fullVariantData.price.amount)
    ) {
      return 'MARKDOWN';
    }

    return null;
  },
  get originalPrice() {
    const { discountStatus, fullVariantData, $store, cartItem } = this;
    if (discountStatus === 'MARKDOWN') {
      const compareAtPrice = parseFloat(fullVariantData.compareAtPrice.amount);
      const { quantity } = cartItem;

      return formatPrice({
        currencyCode: $store.cart.cartData.currency,
        amount: compareAtPrice * quantity,
      });
    } else if (discountStatus === 'APPLIED') {
      return formatPrice({
        currencyCode: $store.cart.cartData.currency,
        amount: cartItem.original_line_price / 100,
      });
    }
    return '';
  },

  get finalPrice() {
    const { $store, cartItem } = this;

    return formatPrice({
      currencyCode: $store.cart.cartData.currency,
      amount: cartItem.final_line_price / 100,
    });
  },
});

export default lineItemComponent;
